import type { ReactElement } from 'react';
import { cloneElement, useId } from 'react';

export type IconColor = string | ReactElement<{ id?: string }>;

export const useIconColor = (color: IconColor | undefined) => {
  const gradientId = useId();
  const fill =
    typeof color === 'object' ? `url(#${gradientId})` : color ?? 'currentColor';
  const svgNode =
    typeof color === 'object' && cloneElement(color, { id: gradientId });
  return { fill, svgNode };
};
